export default __webpack_public_path__ + "static/media/0R.17fec01d.png";